import { useCallback, useEffect, useState } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
import { SearchApi } from "@jti/rest-api";
import { getParams } from "../../../../../utils/getParams";
import { setParams } from "../../../../../utils/setParams";
export const useSearch = ({ type, locale }) => {
    const messageBus = useMessageBus();
    const [isLoading, setIsLoading] = useState(true);
    const [searchText, setSearchText] = useState("");
    const [searchResponse, setSearchResponse] = useState({ data: [], meta: null });
    const resultsPerPage = 20;
    const loadResultsPerPage = 10;
    const getSearchResults = useCallback(async ({ queryParam, perPage, page, isNewSearchQuery = false }) => {
        setIsLoading(true);
        messageBus.publish("search.total.results", {
            payload: { isResultsLoading: true, searchTotalResults: searchResponse.meta?.total ?? 0 },
        });
        try {
            const { data, meta } = await SearchApi.init().getSearchResults({ queryParam, perPage, page, locale, type });
            messageBus.publish("search.total.results", {
                payload: { searchTotalResults: meta?.total, isResultsLoading: false },
            });
            setSearchResponse((prevResponse) => ({
                data: isNewSearchQuery ? data : [...prevResponse.data, ...data],
                meta,
            }));
        }
        catch (e) {
            console.warn("Error fetching search results", e);
        }
        finally {
            setIsLoading(false);
        }
    }, [type, locale]);
    const loadMoreHandler = useCallback(async () => {
        const searchPage = searchResponse.meta?.current_page === 1
            ? (Math.ceil(searchResponse?.data?.length / loadResultsPerPage) ?? 1) + 1
            : searchResponse.meta?.current_page + 1;
        await getSearchResults({
            queryParam: searchText,
            perPage: loadResultsPerPage,
            page: searchPage,
        });
    }, [
        searchResponse?.meta?.current_page,
        searchResponse?.data?.length,
        getSearchResults,
        searchText,
        loadResultsPerPage,
    ]);
    const searchByParam = useCallback(async () => {
        const { q } = getParams("q");
        if (q) {
            setSearchText(q);
            setParams({ q });
            await getSearchResults({ queryParam: q, perPage: resultsPerPage, page: 1, isNewSearchQuery: true });
        }
    }, [setSearchText, getSearchResults, loadResultsPerPage]);
    useEffect(() => {
        searchByParam();
        window.addEventListener("popstate", searchByParam);
        return () => {
            window.removeEventListener("popstate", searchByParam);
        };
    }, [searchByParam]);
    useEffect(() => {
        messageBus.subscribe({
            channel: "search.value",
            callback() {
                searchByParam();
            },
        });
        return () => {
            messageBus.unsubscribe("search.value");
        };
    }, [messageBus, searchByParam]);
    return {
        isLoading,
        searchText,
        searchResponse,
        loadMoreHandler,
    };
};
//# sourceMappingURL=useSearch.js.map